<template>
    <svg width="96" height="42" viewBox="0 0 96.45 41.6531" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <circle cx="20.8265" cy="20.8265" r="19.8265" stroke="#BDC0FF" stroke-width="2" />
        <circle cx="48.225" cy="20.8265" r="19.8265" stroke="#BDC0FF" stroke-width="2" />
        <circle cx="75.6235" cy="20.8265" r="19.8265" stroke="#7478EA" stroke-width="2" />
    </svg>
</template>
